import React from "react";

const HeaderSocials = () => {
  return (
    <div className="home__socials">
      <a
        href=" https://www.instagram.com/henii_ad/"
        className="home__social-link"
        target="_blank"
      >
        <i class="fa-brands fa-instagram"></i>
      </a>

      <a
        href=" https://www.linkedin.com/in/hani-abedellaoui-5a4021288/"
        className="home__social-link"
        target="_blank"
      >
        <i class="fa-brands fa-linkedin"></i>
      </a>

      <a
        href=" https://www.behance.net/elheniabdella"
        className="home__social-link"
        target="_blank"
      >
        <i class="fa-brands fa-behance"></i>
      </a>

      <a
        href=" https://github.com/ElheniAbdellaoui"
        className="home__social-link"
        target="_blank"
      >
        <i class="fa-brands fa-github"></i>
      </a>

      <a
        href=" https://www.facebook.com/hani.mbarki.12"
        className="home__social-link"
        target="_blank"
      >
        <i class="fa-brands fa-facebook"></i>
      </a>
    </div>
  );
};

export default HeaderSocials;
